<template>
	 <div :class="$route.meta.bodyClass">    
		<div class="background-ui"></div>
		<headerSection/>
		<router-view :key="$route.fullPath"></router-view>
		<footerSection />
	</div>
</template>
<script>
	import footerSection from '../shared/FooterSection'
	import headerSection from '../shared/HeaderSection'
	export default {
	name: 'default',
	components: {
	footerSection,
	headerSection
	}
	}
</script>
